import React from "react";
import { FiPlus } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";

const Loan_Inquiry_StatusHeader = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  return (
    <>
      <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
        <Link
          to={`/master/add-inquiry-status?id=${M_id}`}
          className="btn btn-primary"
        >
          <FiPlus size={16} className="me-2" />
          <span>Create Inquiry Status</span>
        </Link>
      </div>
    </>
  );
};

export default Loan_Inquiry_StatusHeader;
